import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingStockCountEditView from 'src/sections/packaging-stock-count/view/packaging-stock-count-edit-view';

export default function PackagingStockCountEditPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Edit packaging stock count</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingStockCountEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
